import * as React from 'react';
import { useEffect, useRef } from 'react';
import * as showdown from 'showdown';
import { styled } from '../theme';

export class UnsafeMarkdown {
  constructor(public readonly text: string) {}
}

export interface MarkdownWidgetProps {
  content: UnsafeMarkdown;
  className?: any;
}

export const MarkdownWidget: React.FC<MarkdownWidgetProps> = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!props.content.text) {
      return;
    }
    let images = ref.current?.querySelectorAll('img');

    let callbacks: (() => any)[] = [];

    images?.forEach((img) => {
      const click = () => {
        window.open(img.src, '_blank');
      };

      img.addEventListener('click', click);
      callbacks.push(() => {
        img.removeEventListener('click', click);
      });
    });
    return () => {
      callbacks.forEach((c) => c());
    };
  }, [props.content.text]);

  if (!props.content?.text) {
    return null;
  }
  const converter = new showdown.Converter({ simpleLineBreaks: true });
  return (
    <S.Text
      ref={ref}
      className={props.className}
      dangerouslySetInnerHTML={{ __html: converter.makeHtml(props.content.text) }}
    />
  );
};

namespace S {
  export const Text = styled.div`
    display: block;
    font-family: ${(p) => p.theme.text.fontFamily};

    img {
      cursor: pointer;
    }

    h1,
    h2,
    h3 {
      margin-bottom: 10px;
      color: ${(p) => p.theme.text.primary};
    }

    p {
      color: ${(p) => p.theme.text.secondary};
      margin-bottom: 10px;

      :last-of-type {
        margin-bottom: 0;
      }
    }
  `;
}
